<template>
    <div class="statistics_panel">
        <div class="statistics_search">
            <div class="time_search">
                <span class="title">{{$t('message.Time')}}：</span>
                <el-radio-group @change="getType" v-model="timeType">
                    <el-radio :label="0">{{$t('message.ThisMonth')}}</el-radio>
                    <el-radio :label="1">{{$t('message.ThisSeason')}}</el-radio>
                    <el-radio :label="2">{{$t('message.ThisYear')}}</el-radio>
                    <el-radio :label="3">
                        <el-date-picker
                                @change="getDate"
                                end-placeholder=" "
                                range-separator="-"
                                start-placeholder=" "
                                type="daterange"
                                v-model="checkData"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-radio>
                </el-radio-group>
            </div>
            <div class="company_search">
                <span class="title">{{$t('message.Company')}}：</span>
                <el-select @change="getOCRReport" clearable
                           filterable
                           placeholder=" "
                           v-model="CompanyCode">
                    <el-option
                            :key="index"
                            :label="item.Name"
                            :value="item.Code"
                            v-for="(item, index) in companyOptions">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="statistics_main" v-loading="isLoading">
            <div class="total_panel">
                <div class="title">{{$t('message.TotalStatistics')}}</div>
                <div class="statistics_lists">
                    <div :key="index" class="statistics_list" v-for="(item, index) in statisticsLists">
                        <div class="statistics_list_name">
                            <span>{{$t('message.' + item.name)}}</span>
                            <el-tooltip
                                    :content="$t('message.' + item.tips)"
                                    class="item"
                                    effect="dark"
                                    placement="top">
                                <i class="iconfont icon-bangzhu-kong" v-if="item.tips !== ''"></i>
                            </el-tooltip>
                        </div>
                        <div class="statistics_list_total">{{item.total}}</div>
                        <div class="statistics_list_ok">
                            <i class="iconfont icon-gou-kong" v-if="item.okNum"></i>
                            <span>{{item.okNum}}</span>
                        </div>
                        <div class="statistics_list_err">
                            <i class="iconfont icon-guanbi-kong" v-if="item.okNum"></i>
                            <span>{{item.errNum}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="statistics_table">
                <div class="title">{{$t('message.DetailedData')}}</div>
                <div class="table_container">
                    <el-button-group>
                        <el-tooltip :content="$t('message.DownloadExcel')" class="item" effect="dark" placement="top">
                            <el-button @click="handleDownload" class="icon iconfont icon-xiazai-kong"
                                       type="primary"></el-button>
                        </el-tooltip>
                    </el-button-group>
                    <el-table
                            :data="tableData"
                            :header-cell-style="{'background-color': '#f8f8f9', 'color': '#262626'}"
                            :row-key="row => row.index"
                            class="table_list table_border"
                            ref="multipleTable"
                            stripe>
                        <el-table-column
                                :label="$t('message.Time')"
                                :min-width="tableW[0]"
                                prop="CreateTime"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.Recognitions')"
                                :min-width="tableW[1]"
                                align="right"
                                prop="OCRSumCount"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.SuccessRecognitions')"
                                :min-width="tableW[2]"
                                align="right"
                                prop="OCRSuccessCount"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.FailureRecognitions')"
                                :min-width="tableW[3]"
                                align="right"
                                prop="OCRFailureCount"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.Verifications')"
                                :min-width="tableW[4]"
                                align="right"
                                prop="CheckTrueSumCount"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.SuccessVerifications')"
                                :min-width="tableW[5]"
                                align="right"
                                prop="CheckTrueSuccessCount"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.FailureVerifications')"
                                :min-width="tableW[6]"
                                align="right"
                                prop="CheckTrueFailureCount"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.Modifications')"
                                :min-width="tableW[7]"
                                align="right"
                                prop="ChangeCount"
                                sortable>
                        </el-table-column>
                    </el-table>
                    <div class="Pagination">
                        <el-pagination
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 30, 40]"
                                :total="count"
                                @current-change="handleCurrentChange"
                                @size-change="handleSizeChange"
                                background
                                layout="total, sizes, prev, pager, next, jumper">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {baseUrl} from "../config/env";
    import {OCRReport, GetCompany,DownLoadOCRResultData} from "../api/apiStatistics";
    
    import {
        getLocal,
        getFirstDayOfMonth,
        getLastDayOfMonth,
        getFirstDayOfSeason,
        getLastDayOfSeason,
        getFirstDayOfYear,
        getLastDayOfYear
    } from "../config/mUtils";

    export default {
        name: "statisticsPanel",
        props: ['SupplierId'],
        data() {
            return {
                baseUrl,
                timeType: 0,
                checkData: ['', ''],
                CompanyCode: '',
                companyOptions: [],
                DateSubmit: [getFirstDayOfMonth(new Date()), getLastDayOfMonth(new Date())],
                isLoading: false,
                statisticsLists: [
                    {
                        name: 'TotalIdentification',
                        tips: '',
                        total: 0,
                        okNum: 0,
                        errNum: 0
                    }, {
                        name: 'TotalVerification',
                        tips: '',
                        total: 0,
                        okNum: 0,
                        errNum: 0
                    }, {
                        name: 'TotalModify',
                        tips: '',
                        total: 0
                    }, {
                        name: 'RecognitionRate',
                        tips: 'RecognitionRateFormula',
                        total: 0 + '%'
                    }
                ],
                tableData: [],
                offset: 1,
                limit: 10,
                count: 0,
                currentPage: 1,
                normalW: {
                    cn: ['70', '90', '110', '110', '90', '110', '110', '90'],
                    en: ['90', '130', '170', '170', '120', '180', '170', '130']
                },
                tableW: [],
            }
        },
        created() {
            this.initData();
            this.resetLabelWidth();
        },
        computed: {
            langChange() {
                return this.$i18n.locale;
            }
        },
        watch: {
            langChange(val) {
                if (val) {
                    this.resetLabelWidth();
                }
            }
        },
        methods: {
            resetLabelWidth() {
                if (getLocal('language') === 'zh-CN') {
                    this.tableW = this.normalW.cn;
                } else {
                    this.tableW = this.normalW.en;
                }
            },
            async initData() {
                try {
                    this.getCompany();
                    this.getOCRReport();
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取供应商信息
            async getCompany() {
                this.companyOptions = [];
                try {
                    let data = await GetCompany();
                    if (data.error_code === '0') {
                        data.data.forEach(ele => {
                            let company = {
                                Code: ele.CompanySAPCode
                            }
                            if (getLocal('language') === 'zh-CN') {
                                company.Name = ele.CompanyName;
                            } else {
                                company.Name = ele.CompanyShortName;
                            }
                            this.companyOptions.push(company);
                        })
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 获取当前选中时间类型
            getType(val) {
                this.timeType = val;
                this.DateSubmit = [];
                if (val === 0) {
                    this.DateSubmit = [getFirstDayOfMonth(new Date()), getLastDayOfMonth(new Date())];
                    this.checkData = ['', ''];
                } else if (val === 1) {
                    this.DateSubmit = [getFirstDayOfSeason(new Date()), getLastDayOfSeason(new Date())];
                    this.checkData = ['', ''];
                } else if (val === 2) {
                    this.DateSubmit = [getFirstDayOfYear(new Date()), getLastDayOfYear(new Date())];
                    this.checkData = ['', ''];
                } else if (val === 3) {
                    this.DateSubmit = this.checkData;
                }
                this.getOCRReport();
            },
            // 获取更改后的时间
            getDate(val) {
                this.timeType = 3;
                this.DateSubmit = val;
                this.getOCRReport();
            },
            // OCR验真详情数据统计报表
            async getOCRReport() {
                this.tableData = [];
                this.isLoading = true;
                try {
                    let data = await OCRReport(
                        this.SupplierId,
                        this.DateSubmit[0],
                        this.DateSubmit[1],
                        this.CompanyCode,
                        getLocal('language'),
                        this.offset,
                        this.limit
                    );
                    if (data.error_code === '0') {
                        this.isLoading = false;
                        this.count = data.data.lstOCRReportReturnCount;
                        this.tableData = data.data.lstOCRReportReturn;
                        this.statisticsLists = [
                            {
                                name: 'TotalIdentification',
                                tips: '',
                                total: data.data.OCRSumCount,
                                okNum: data.data.OCRSuccessCount,
                                errNum: data.data.OCRFailureCount
                            }, {
                                name: 'TotalVerification',
                                tips: '',
                                total: data.data.CheckTrueSumCount,
                                okNum: data.data.CheckTrueSuccessCount,
                                errNum: data.data.CheckTrueFailureCount
                            }, {
                                name: 'TotalModify',
                                tips: '',
                                total: data.data.ChangeCount
                            }, {
                                name: 'RecognitionRate',
                                tips: 'RecognitionRateFormula',
                                total: data.data.RecognitionRate + '%'
                            }
                        ]
                    } else {
                        this.isLoading = false;
                    }
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            },
            // 更改每页显示数据条数
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.offset = 1;
                this.getOCRReport();
            },
            // 更改当前页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.offset = val;
                this.getOCRReport();
            },
            // 下载Excel
            async handleDownload() {
                let param = `SupplierId=${this.SupplierId}&DateStart=${this.DateSubmit[0]}&DateEnd=${this.DateSubmit[1]}`
                let data = await DownLoadOCRResultData(param);
                if (data) {
                    this.$downFile(data)
                }

            },
        }
    }
</script>

<style scoped>

</style>
